import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=e5920596&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
import style0 from "./evaluationTheme.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=e5920596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5920596",
  null
  
)

export default component.exports